import { CSSProperties } from "react";

export const transitions = (property: keyof CSSProperties) => ({
  hover: `${property} 150ms cubic-bezier(0, 0, 0.3, 1)`,
});
